import { Button } from 'uikit';
import { getCheckedIdsArr } from 'utils';

import { useCallback, useMemo, useState } from 'react';

import { AgreementsAddTable } from '../AgreementsAddTable';
import { useAddUerAgreements } from '../hooks/useAddUerAgreements';
import { useAgreementTableAddUer } from '../hooks/useAgreementTableAddUer';

export const AddAgreementPriceUer = ({
    refreshData,
    refreshFilters,
    disabledByStatus,
    isDisabledByProjectStatus,
    isDisabledByContractStatus,
    isDisabledRulesAccess,
}: {
    refreshData: () => void;
    refreshFilters: () => void;
    disabledByStatus: boolean;
    isDisabledByProjectStatus: boolean;
    isDisabledByContractStatus: boolean;
    isDisabledRulesAccess: boolean;
}) => {
    const [isModalOpened, setIsModalOpened] = useState(false);

    const openAddModalHandler = useCallback(() => setIsModalOpened(true), []);
    const closeAddModalHandler = useCallback(() => setIsModalOpened(false), []);

    const {
        titleModal,
        searchPlaceholder,
        searchString,
        handleChange,
        handleSearch,
        handleClearSearch,
        finalColumns,
        agreementId,
        checkedIds,
        agreementsData,
        agreementsStatus,
        agreementsErrors,
        isSubmittedDataTable,
        handleCloseErrorAgreementTable,
        dataSource,
    } = useAgreementTableAddUer({ isModalOpened });

    const {
        titleAddError,
        addUerAgreementsData,
        addUerAgreementsStatus,
        addUerAgreementsError,
        isSubmittedAddMtr,
        handleAddUerAgreements,
        handleCloseErrorModalAddUer,
        handleCreateReportAddUer,
    } = useAddUerAgreements({ agreementId, checkedIds, refreshData, closeAddModalHandler, refreshFilters });

    const isConfirmDisabled = useMemo(() => !getCheckedIdsArr(checkedIds).length, [checkedIds]);

    return (
        <>
            <Button
                label="Добавить расценки"
                size="s"
                view="secondary"
                onClick={openAddModalHandler}
                disabled={
                    disabledByStatus || isDisabledByProjectStatus || isDisabledByContractStatus || isDisabledRulesAccess
                }
            />
            {isModalOpened && (
                <AgreementsAddTable
                    tableColumns={finalColumns}
                    dataSource={dataSource}
                    isConfirmDisabled={isConfirmDisabled}
                    titleModal={titleModal}
                    handleCloseAddAgreements={closeAddModalHandler}
                    searchPlaceholder={searchPlaceholder}
                    searchString={searchString}
                    handleChange={handleChange}
                    handleSearch={handleSearch}
                    handleClearSearch={handleClearSearch}
                    isSubmittedDataTable={isSubmittedDataTable}
                    agreementsData={agreementsData}
                    agreementsStatus={agreementsStatus}
                    agreementsErrors={agreementsErrors}
                    handleAddAgreements={handleAddUerAgreements}
                    isSubmittedAddMtr={isSubmittedAddMtr}
                    addAgreementsData={addUerAgreementsData}
                    addAgreementsStatus={addUerAgreementsStatus}
                    addAgreementsError={addUerAgreementsError}
                    handleCloseErrorModalAdd={handleCloseErrorModalAddUer}
                    handleCreateReportAdd={handleCreateReportAddUer}
                    titleAddError={titleAddError}
                    handleCloseErrorAgreementTable={handleCloseErrorAgreementTable}
                />
            )}
        </>
    );
};

AddAgreementPriceUer.displayName = 'AddAgreementPriceUer';
